/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_PositionInputs */

const en_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const fr_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poste`)
};

const es_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puesto`)
};

const it_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const nl_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functie`)
};

const pl_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stanowisko`)
};

const fi_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävä`)
};

const da_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilling`)
};

const sv_resume_editor_position = /** @type {(inputs: Resume_Editor_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befattning`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Resume_Editor_PositionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_position = /** @type {((inputs?: Resume_Editor_PositionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_PositionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_position(inputs)
	if (locale === "fr") return fr_resume_editor_position(inputs)
	if (locale === "es") return es_resume_editor_position(inputs)
	if (locale === "it") return it_resume_editor_position(inputs)
	if (locale === "nl") return nl_resume_editor_position(inputs)
	if (locale === "pl") return pl_resume_editor_position(inputs)
	if (locale === "fi") return fi_resume_editor_position(inputs)
	if (locale === "da") return da_resume_editor_position(inputs)
	if (locale === "sv") return sv_resume_editor_position(inputs)
	return en_resume_editor_position(inputs)
});